import type { IModuleSummary } from '@platform/core/types';
import type { IMappingPlan } from './IMappingPlan';
import { mappingScopes } from './mappingScopes';

/**
 * Що показати в панелі «Зіставлення», доки запит порожній (прототип v4: усі записи модулів простору або вибраного, «Показано 30 з N»,
 * у порядку модулів простору): типи з mappingScopes, що мають записи; `scope` — ключ типу (фільтр «У:»), а якщо такого типу немає —
 * ключ модуля (усі його типи; «+ Зв’язати» картки пов'язаних записів); `total` — сума їх записів. Чиста функція.
 */
export function mappingPlan(modules: readonly IModuleSummary[], scope: string): IMappingPlan {
  const scopes = mappingScopes(modules);
  const byType = scopes.some((s) => s.key === scope);
  const count = new Map(modules.flatMap((m) => m.recordTypes.map((r) => [`${m.key}:${r.key}`, r.recordCount] as const)));
  const types = scopes.filter((s) => (!scope || (byType ? s.key === scope : s.module === scope)) && (count.get(`${s.module}:${s.key}`) ?? 0) > 0);
  return { types: types.map((s) => s.key), total: types.reduce((n, s) => n + (count.get(`${s.module}:${s.key}`) ?? 0), 0) };
}
